import { AlertCircle } from 'lucide-react';
import { studioBOn } from '@/lib/studioB/flag';

/** A notice about the user's own model key names "Settings": that word links to where the key is kept. */
const KEY_SETTINGS = /^(.*?\bmodel key\b.*?\b)Settings\b(.*)$/s;

function NoticeText({ message }: { message: string }) {
  const m = KEY_SETTINGS.exec(message);
  if (!m) return <span>{message}</span>;
  return (
    <span>
      {m[1]}<a href="/settings/advanced" className="underline underline-offset-2 hover:text-foreground">Settings</a>{m[2]}
    </span>
  );
}

export function ChatErrorNotice({ message }: { message: string }) {
  if (studioBOn()) {
    return (
      <div role="alert" className="my-1 flex items-start gap-2.5 rounded-[var(--b-radius-card)] border border-b-line bg-b-elevated px-3.5 py-2.5 text-b-read text-b-t1">
        <span aria-hidden className="mt-[7px] h-2 w-2 flex-none rounded-full bg-destructive" />
        <NoticeText message={message} />
      </div>
    );
  }
  return (
    <div role="alert" className="my-1 flex items-start gap-2 rounded-lg border border-destructive/30 bg-destructive/5 px-3 py-2 text-[13px] leading-5 text-foreground">
      <AlertCircle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-destructive" aria-hidden="true" />
      <NoticeText message={message} />
    </div>
  );
}

export function TurnMeta({ text }: { text: string }) {
  return (
    <div className="flex items-center gap-1.5 py-0.5 text-[11px] text-muted-foreground">
      <span className="h-px flex-1 bg-border-secondary" aria-hidden="true" />
      <span className="tabular-nums">{text}</span>
      <span className="h-px flex-1 bg-border-secondary" aria-hidden="true" />
    </div>
  );
}
